var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app no-header"},[_c('w-questions',{attrs:{"answers":_vm.answers,"message-show":_vm.message.show,"sections":['pool_name', 'other_questions', 'equipment', 'address']},on:{"save":_vm.submit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }